import * as React from 'react';

export interface SidebarSectionTitleProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Usually plain text, but could be any renderable node */
  children: React.ReactNode;
}

export class SidebarSectionTitle extends React.PureComponent<SidebarSectionTitleProps> {}
